import { FunctionComponent, h } from 'preact';
import { Icon } from 'components/icon/icon';
import { useTranslation } from 'hooks';
import { useContext, useEffect } from 'preact/hooks';
import { ApplicationContext } from 'contexts/use-application-setup';
import { headerStore } from 'global/header.store';
import { INITIAL_PAGE_STATE } from 'constants/constants';

import './lst-upgrade.scss';
import { redirectToDashboard } from 'helpers/redirect-to-dashboard';

export const LstUpgrade: FunctionComponent = () => {
  const { translate } = useTranslation();
  const { tunings } = useContext(ApplicationContext);

  useEffect(() => {
    headerStore.backState.next(INITIAL_PAGE_STATE);
  }, []);

  const handleRedirect = () => {
    const redirectPath = `/widget/my-sites/p/1/site-details/addons?site=${tunings?.site_name}#lst-addon`;
    redirectToDashboard(redirectPath);
  };

  return (
    <div className="uwaw-lst-upgrade-card">
      <div className="uwaw-lst-upgrade-card__inner">
        <div className="uwaw-lst-upgrade-card__header">
          <div>
            <h2 className="uwaw-lst-upgrade-card__title">
              {translate('widget.lst_upgrade.title')}
            </h2>
            <p className="uwaw-lst-upgrade-card__subtitle">
              {translate('widget.lst_upgrade.description')}
            </p>
          </div>
          <div className="uwaw-lst-upgrade-card__icon">
            <Icon type="lst-flags" />
          </div>
        </div>

        <div className="uwaw-lst-upgrade-card__footer">
          <a
            href="#"
            className="uwaw-lst-upgrade-card__button uwaw-btn__primary"
            onClick={handleRedirect}
            role="link"
          >
            {translate('widget.upgrade.button')}
          </a>
        </div>
      </div>
    </div>
  );
};
